// extracted by mini-css-extract-plugin
export default {"wrapperClass":"Wrapper_wrapperClass__xiyor"};